var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1.5H8V0.5H7V1.5H3V0.5H2V1.5H1.5C0.945 1.5 0.505 1.95 0.505 2.5L0.5 9.5C0.5 10.05 0.945 10.5 1.5 10.5H8.5C9.05 10.5 9.5 10.05 9.5 9.5V2.5C9.5 1.95 9.05 1.5 8.5 1.5ZM8.5 9.5H1.5V4H8.5V9.5ZM2.5 5H5V7.5H2.5V5Z",
    fill: "#E3E3E3",
    fillOpacity: 0.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.ffa3c837be6d16fb37ab2509a1b41c33.svg";
export { ForwardRef as ReactComponent };